export default "__VITE_ASSET__1vYqFtMG__"